import { createStyles } from "@mantine/emotion";

export const useStylesModal = createStyles((theme) => ({
  wrap: {
    ".modal-title": {
      fontSize: theme.spacing.modal.title.fontSize,
      textAlign: "center",
      marginTop: theme.spacing.modal.title.marginTop,
      marginBottom: theme.spacing.modal.title.marginBottom,
    },
  },
}));
